import { frontendURL } from '../../../../helper/URLHelper';
import SettingsWrapper from '../SettingsWrapper.vue';

const LeadSourcesIndex = () => import('./Index.vue');

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/lead-sources'),
      component: SettingsWrapper,
      children: [
        {
          path: '',
          redirect: to => ({ name: 'settings_lead_sources', params: to.params }),
        },
        {
          path: 'list',
          name: 'settings_lead_sources',
          component: LeadSourcesIndex,
          meta: { permissions: ['administrator'] },
        },
      ],
    },
  ],
};
